// 🔹 Status Labels
export const OrderStatus = Object.freeze({
  ALL: "All",
  MISSING_RX: "Missing Rx",
  UNFILLED_RX: "Unfilled Rx",
  READY_TO_MAKE: "Ready to make",
  LENSES_SENT: "Lenses sent",
  READY_TO_ASSEMBLE: "Ready to assemble",
  READY_TO_SHIP: "Ready to ship",
  SHIPPED: "Shipped",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
});

// 🔹 Status Codes
export const OrderCode = Object.freeze({
  ALL: "all",
  MISSING_RX: "0",
  UNFILLED_RX: "1",
  READY_TO_MAKE: "2",
  LENSES_SENT: "3",
  READY_TO_ASSEMBLE: "4",
  READY_TO_SHIP: "5",
  SHIPPED: "6",
  DELIVERED: "7",
  CANCELLED: "999",
});

// 🔹 Tab Config (auto-generated from codes + labels)
export const tabConfig = Object.entries(OrderCode).map(([key, value]) => {
  // For "ALL", don’t prefix with number
  if (key === "ALL") {
    return { key: value, label: OrderStatus[key] };
  }

  return {
    key: value,
    label: `${value.padStart(2, "0")} | ${OrderStatus[key]}`,
  };
});


export const generateStatusesOptions = () => {
  // Exclude ALL since you don't want it in output
  const excludeKeys = ["ALL"];

  return Object.keys(OrderStatus)
    .filter((key) => !excludeKeys.includes(key))
    .map((key) => {
      const value = OrderCode[key];
      return {
        code: value === "999" ? "999" : value.padStart(2, "0"), // pad 0 for normal codes
        label: OrderStatus[key],
        value: value,
      };
    });
};

// ✅ Usage
export const statusesOptions = generateStatusesOptions();


export const FactoryLabel = Object.freeze({
  WANXIN: "Wanxin",
  MENGSHI: "Mengshi",
  SHENZHEN: "Shenzhen office",
  SAN_FRANCISCO: "San Francisco office",
});

// 🔹 Factory Codes (VALUES IN CAPITAL)
export const FactoryCode = Object.freeze({
  WANXIN: "WANXIN",
  MENGSHI: "MENGSHI",
  SHENZHEN: "SHENZHEN",
  SAN_FRANCISCO: "SAN_FRANCISCO",
});

// 🔹 Generate Factory Options
export const generateFactoryOptions = () => {
  return Object.keys(FactoryLabel).map((key) => {
    return {
      label: FactoryLabel[key],
      value: FactoryCode[key], // capital values
    };
  });
};

// ✅ Usage
export const factoryOptions = generateFactoryOptions();